import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6abf88c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-user-group" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bottom_pop_up_item = _resolveComponent("bottom-pop-up-item")!
  const _component_app_bottom_pop_up = _resolveComponent("app-bottom-pop-up")!

  return (_openBlock(), _createBlock(_component_app_bottom_pop_up, {
    onHide: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emit('hide'))),
    "hide-bottom-decoration": "",
    "hide-top-decoration": ""
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$localize('contacts.button.title')), 1)
    ]),
    body: _withCtx(() => [
      _createVNode(_component_bottom_pop_up_item, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToAddContacts()))
      }, {
        icon: _withCtx(() => [
          _hoisted_1
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$localize('contacts.button.add.from')) + " ", 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}